/**
 * @generated SignedSource<<41a7a198336d5b918c7ca66919e7f3b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ArchiveArchivableInput = {
  clientMutationId?: string | null;
  archivableId: string;
};
export type FunnelBulkArchiveButton_Mutation$variables = {
  input: ArchiveArchivableInput;
  connections: ReadonlyArray<string>;
};
export type FunnelBulkArchiveButton_MutationVariables = FunnelBulkArchiveButton_Mutation$variables;
export type FunnelBulkArchiveButton_Mutation$data = {
  readonly archiveArchivable: {
    readonly archivable: {
      readonly id: string;
    };
  } | null;
};
export type FunnelBulkArchiveButton_MutationResponse = FunnelBulkArchiveButton_Mutation$data;
export type FunnelBulkArchiveButton_Mutation = {
  variables: FunnelBulkArchiveButton_MutationVariables;
  response: FunnelBulkArchiveButton_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelBulkArchiveButton_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ArchiveArchivablePayload",
        "kind": "LinkedField",
        "name": "archiveArchivable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "archivable",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FunnelBulkArchiveButton_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ArchiveArchivablePayload",
        "kind": "LinkedField",
        "name": "archiveArchivable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "archivable",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cbad58792d382b0909af0dff0d495134",
    "id": null,
    "metadata": {},
    "name": "FunnelBulkArchiveButton_Mutation",
    "operationKind": "mutation",
    "text": "mutation FunnelBulkArchiveButton_Mutation(\n  $input: ArchiveArchivableInput!\n) {\n  archiveArchivable(input: $input) {\n    archivable {\n      __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2eed5e4b2221c93ed91925d9d317531c";

export default node;
